import EoxCallCenter from '@/services/call-center/eox-call-center.service';
import CloudTalkCallCenter from '@/services/call-center/cloudtalk-call-center.service';

export enum CallCenterPartnerEnum {
  EOX = 10,
  CloudTalk = 20,
}

export function getPluginByPartnerCode(): any {
  return {
    [CallCenterPartnerEnum.EOX]: new EoxCallCenter(),
    [CallCenterPartnerEnum.CloudTalk]: new CloudTalkCallCenter(),
  };
}
